import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreeSpinsRecord from "slotworks/model/gameplay/records/freespins-record";
import settingsModel from "slotworks/model/settings/settings-model";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import { isNullOrUndefined } from "util";

export default class Winnings {

    private pendingUpdate: number;
    private currentWin: CurrentWinTicker;
    private totalWin: WinTicker;

    public setup() {
        this.currentWin = new CurrentWinTicker();
        this.totalWin = new WinTicker();
    }

    public setDelayedWinnings(currentWin: number, totalWin?: number, delay: number = 0, tickTime: number = 0) {
        Timer.clearTimeout(this.pendingUpdate);
        this.pendingUpdate = Timer.setTimeout(() => this.setWinnings(currentWin, totalWin, tickTime), delay);
    }

    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0) {
        let isfree = gameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord;
        Timer.clearTimeout(this.pendingUpdate);

        if (isNullOrUndefined(currentWin)) {
            currentWin = 0;
        }

        if (totalWin === undefined) {
            totalWin = currentWin;
        }

        if(isfree){
            const record = gameState.getCurrentGame().getCurrentRecord();
            const freespinRecord :any = record.results[record.results.length-1];
            if(freespinRecord)
            totalWin = freespinRecord.totalWinCash;
        }

        this.setWin(this.totalWin, totalWin, tickTime);
        this.setWin(this.currentWin, currentWin, tickTime);
    }

    private setWin(win: WinTicker, value: number, tickTime: number) {
        if (win.actionNeeded(value)) {
            if (win.ticking()) {
                win.stop();
            }

            win.start(value, tickTime);
        }

        return;
    }
}

class WinTicker {
    public tickingValue: number = 0;
    public totalValue: number = 0;
    protected tween: TweenJS.Tween = null;

    constructor() {
        //
    }

    // NaN means 'don't change'
    public actionNeeded(value: number) {
        return value !== null && !isNaN(value) && value !== this.totalValue;
    }

    public ticking(): boolean {
        return this.tween !== null;
    }

    public stop() {
        if (this.ticking()) {
            this.tween.stop();
        }
        this.tween = null;
    }

    public start(value: number, tickTime: number) {
        if (tickTime > 0 && value > 0) {
            this.tickUp(value, tickTime);
        } else {
            this.go(value);
        }
    }

    public update(value: number) {
        Components.betBar.setTotalWin(value);
        Components.betMenu.setTotalWin(value);
    }

    protected tickUp(value: number, tickTime: number) {
        // protect against ticking backwards
        if (value < this.totalValue) {
            this.totalValue = 0;
        }

        this.tickingValue = this.totalValue;
        const tickObject = {t: this.tickingValue};
        this.totalValue = value;

        this.tween = new TweenJS.Tween(tickObject)
            .to({t: value}, tickTime)
            .onUpdate(() => {
                this.tickingValue = tickObject.t;
                if(settingsModel.removeTrailingDecimals && settingsModel.socialSweepstakes) {
                    this.tickingValue = Math.floor(this.tickingValue/100) * 100;
                }
                this.update(this.tickingValue);
            })
            .onComplete(() => {
                this.update(this.totalValue);
                this.tickingValue = this.totalValue;
                this.stop();
            })
            .start();
    }

    protected go(value: number) {
        this.tickingValue = value;
        this.totalValue = value;
        this.update(value);
    }
}

class CurrentWinTicker extends WinTicker {

    public start(value: number, tickTime: number) {
        super.start(value, tickTime);
        if (value > 0 && tickTime > 0) {
            SoundManager.event(SoundEvent.winnings_countup);
        }
    }

    public stop() {
        super.stop();
        SoundManager.event(SoundEvent.winnings_countup_end);
    }

    public update(value: number) {
        Components.betBar.setCurrentWin(value);
    }

    protected tickUp(value: number, tickTime: number) {
        // always reset to 0 and count up from there for current win
        this.totalValue = 0;

        super.tickUp(value, tickTime);
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/components/betbar/winnings/winnings.ts